import { useSearchParams } from 'react-router-dom';

import { SearchType } from '../../types';

export function useHistoryFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const filters: SearchType = {
    projectId: searchParams.get('projectId') || '',
    pipelineName: searchParams.get('pipelineName') || '',
    page: parseInt(searchParams.get('page') || '0', 10)
  };

  const setParams = (values: SearchType) => {
    setSearchParams(values as unknown as Record<string, string>);
  };

  const changePage = (page = 0) => {
    setParams({
      ...filters,
      page
    });
  };

  return { filters, setParams, changePage };
}
